/* Overrides on the shadcn sidebar rows: a light tint on hover instead of the
 * accent fill, which here marks the selected row along with a border. */
const tintHover = [
  'hover:ds-bg-sidebar-tint hover:ds-text-sidebar-foreground',
  'active:ds-bg-sidebar-tint active:ds-text-sidebar-foreground',
  'data-[active=true]:hover:ds-bg-sidebar-accent data-[active=true]:hover:ds-text-sidebar-accent-foreground'
];

export const navRowClassName = [
  'ds-h-[38px] ds-px-3 ds-py-2 ds-pr-[84px] ds-border ds-border-transparent ds-text-sidebar-foreground',
  // Repeated under SidebarMenuButton's own group-has variant, which would otherwise win.
  'group-has-[[data-sidebar=menu-action]]/menu-item:ds-pr-[84px]',
  'data-[active=true]:ds-border-sidebar-accent-border data-[active=true]:ds-font-normal',
  ...tintHover
].join(' ');

export const navLeafClassName = ['ds-h-8 ds-w-full ds-px-1 ds-pr-9 ds-text-left', ...tintHover].join(' ');

export const navCountPillClassName = 'ds-h-[22px] ds-rounded-[10px] ds-bg-sidebar-tint ds-px-2 ds-text-xs ds-font-semibold ds-tabular-nums';

export const navActionClassName = [
  'hover:ds-bg-sidebar-tint hover:ds-text-sidebar-foreground',
  'peer-hover/menu-button:ds-text-sidebar-foreground',
  'peer-data-[active=true]/menu-button:ds-text-sidebar-accent-foreground',
  'peer-data-[active=true]/menu-button:hover:ds-text-sidebar-accent-foreground'
].join(' ');
